import {
  calculateDiscountedInvoiceGrosze,
  type MentoringDiscount,
  MINIMUM_INVOICE_GROSZE,
  planDiscountPhases
} from '@algoacademy/backend/modules/payment/discount-pricing'
import {
  calculateRenewalPriceZloty,
  type MentoringOfferProduct
} from '../../../_forms/MentoringOfferForm/_helpers/mentoring-terms'

const GROSZE_PER_ZLOTY = 100

export type DiscountPreviewFigures = {
  /** What one invoice costs today, before staff touches anything. */
  listInvoiceGrosze: number
  /** What that same invoice costs with this discount on it. */
  discountedInvoiceGrosze: number
  savingsGrosze: number
  /** null while the discount never ends - every invoice then looks like the first one. */
  ending: {
    /** The figure the subscription goes back to once the discount is spent. */
    fullPriceGrosze: number
    periodCount: number
  } | null
  /** The discount digs past 20 zł gross, so the invoice stops at the floor instead. */
  isAtMinimumInvoice: boolean
}

/**
 * Every figure staff reads comes from here, and every figure here comes from the
 * pricing module and the price book - the same two sources checkout uses. Nothing
 * about percent, złoty, rounding or the 20 zł floor is worked out a second time,
 * so the preview cannot quote a price the buyer will not be charged.
 */
export function readDiscountPreviewFigures(args: {
  mentoringProduct: MentoringOfferProduct
  discount: MentoringDiscount
}): DiscountPreviewFigures {
  const { mentoringProduct, discount } = args

  const listInvoiceGrosze = calculateRenewalPriceZloty(mentoringProduct) * GROSZE_PER_ZLOTY

  const discountedInvoiceGrosze = calculateDiscountedInvoiceGrosze({
    listInvoiceGrosze,
    discount
  })

  const { fullPriceGrosze } = planDiscountPhases({
    listInvoiceGrosze,
    discount
  })

  return {
    listInvoiceGrosze,
    discountedInvoiceGrosze,
    savingsGrosze: listInvoiceGrosze - discountedInvoiceGrosze,
    ending:
      discount.periodCount === null ? null : { fullPriceGrosze, periodCount: discount.periodCount },
    isAtMinimumInvoice: discountedInvoiceGrosze === MINIMUM_INVOICE_GROSZE
  }
}

export { formatBillingPeriodCount } from '../../../_forms/MentoringOfferForm/_helpers/mentoring-terms'
